// @ts-nocheck
import * as Types from '../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TDeleteProfileMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type TDeleteProfileMutation = { __typename?: 'Mutation', deleteProfile?: { __typename?: 'DeleteProfilePayload', clientMutationId?: string | null } | null };


export const DeleteProfileDocument = gql`
    mutation DeleteProfile($id: String!) {
  deleteProfile(input: {id: $id, clientMutationId: ""}) {
    clientMutationId
  }
}
    `;
export type TDeleteProfileMutationFn = Apollo.MutationFunction<TDeleteProfileMutation, TDeleteProfileMutationVariables>;

/**
 * __useDeleteProfileMutation__
 *
 * To run a mutation, you first call `useDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileMutation, { data, loading, error }] = useDeleteProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProfileMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteProfileMutation, TDeleteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TDeleteProfileMutation, TDeleteProfileMutationVariables>(DeleteProfileDocument, options);
      }
export type DeleteProfileMutationHookResult = ReturnType<typeof useDeleteProfileMutation>;
export type DeleteProfileMutationResult = Apollo.MutationResult<TDeleteProfileMutation>;
export type DeleteProfileMutationOptions = Apollo.BaseMutationOptions<TDeleteProfileMutation, TDeleteProfileMutationVariables>;